/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Material_TotalInputs */

const vi_order_material_total = /** @type {(inputs: Order_Material_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền vật tư`)
};

/**

* @param {Order_Material_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_material_total = /** @type {((inputs?: Order_Material_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Material_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_material_total(inputs)
});